import { Box, Button } from "@mui/material";
import { useReactFlow } from "@xyflow/react";
import { TooltipCustom } from "../ui/tooltip-custom";

// svg
import { ReactComponent as IconMaximize } from "../../assets/svg/maximize-1.svg";
import { ReactComponent as IconZoomIn } from "../../assets/svg/zoom+.svg";
import { ReactComponent as IconZoomOut } from "../../assets/svg/zoom-.svg";

// style
import "./planner-toolbar.css";


export const PlannerToolbar = () => {
  const { zoomIn, zoomOut, fitView } = useReactFlow();

  return (
    <Box className="planner-toolbar">
      <TooltipCustom text={"Zoom in"} placement="top">
        <Button onClick={zoomIn}>
          <IconZoomIn fill="#343745" width="24px" height="24px" />
        </Button>
      </TooltipCustom>

      <TooltipCustom text={"Zoom out"} placement="top">
        <Button onClick={zoomOut}>
          <IconZoomOut fill="#343745" width="24px" height="24px" />
        </Button>
      </TooltipCustom>

      <TooltipCustom text={"Fit view"} placement="top">
        <Button onClick={fitView}>
          <IconMaximize stroke="#343745" width="22px" height="22px" />
        </Button>
      </TooltipCustom>
    </Box>
  );
};
